import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBriefcase,
  FaShoppingCart,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ProfessionalEcommerceWebsiteDesignInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Professional E-commerce Website Design in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Elevate Your Brand</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">E-commerce Website Design</span> in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer professional e-commerce website design
            in **DIFC**, combining stunning visuals with seamless functionality
            to create online stores that impress and perform in Dubai’s
            financial hub.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1587440871875-191322ee64b0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Professional web designer working
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Professional team meeting
          "https://images.unsplash.com/photo-1541462608143-67571c6738dd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // UX/UI design process
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Design Professionally"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Design Services in DIFC"
        description="We craft e-commerce websites with professionalism at the core."
        cards={[
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Expert Craftsmanship",
            description: "Precision designs by seasoned professionals.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales-Driven Layouts",
            description: "Optimized for conversions and customer trust.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Stunning Aesthetics",
            description: "Visually captivating designs that stand out.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Performance",
            description: "Quick-loading sites for a smooth experience.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Excellence",
            description: "Responsive designs for all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Pros",
            description: "DIFC’s choice for professional e-commerce.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Professional Design Process"
        description={
          <Description>
            We create professional e-commerce websites with a refined approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Align with your brand vision and goals.</li>
              <li>Design: Develop sleek, user-focused layouts.</li>
              <li>Development: Build with precision and scalability.</li>
              <li>Testing: Ensure flawless functionality and appeal.</li>
              <li>Launch: Deliver a polished store ready to shine.</li>
              <li>Support: Offer ongoing refinement and assistance.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Designer creating e-commerce layout
          "https://images.unsplash.com/photo-1600132806370-bf17e65e942f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Professional design tools
          "https://images.unsplash.com/photo-1599041122665-d7a3fbe5a158?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Modern e-commerce interface
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Professional Wins in DIFC"
        description="Our designs have elevated e-commerce standards."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Conversion Boost",
            description: "Doubled sales with a sleek redesign.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Impact",
            description: "Enhanced visibility for a DIFC retailer.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "96% satisfaction from professional clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Professional Design?</Subheading>}
        heading="Professional E-commerce in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for professional e-commerce website
            design in DIFC. Get a sophisticated, high-performing store that
            reflects your brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Professional design team collaborating
          "https://images.unsplash.com/photo-1575318634028-6a0cfcb60d0b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Dubai business district
          "https://images.unsplash.com/photo-1586717791821-3f44a563fa4c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Professional e-commerce website mockup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
